import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import includes from "lodash/includes";

type YmmeState = Readonly<{
    makes: any;
    models: any;
    years: any;
    engines: any;
    active: boolean;
}>;

const initialYmmeState: YmmeState = {
    makes: {
        list: [],
        selection: "",
    },
    models: {
        list: [],
        selection: "",
    },
    years: {
        list: [],
        selection: "",
    },
    engines: {
        list: [],
        selection: "",
    },
    active: false,
};

export const ymmeReducer = createTypedReducerWithImmer(initialYmmeState, {
    "Custom/Ymme/ToggleActive": (draft: Draft<YmmeState>, action: any) => {
        draft.active = action.parameter;
    },
    "Custom/Ymme/MakesLoaded": (draft: Draft<YmmeState>, action: any) => {
        if (action.parameter.successful === false || action.parameter.result.length === 0) {
            draft.makes.list = [];
        } else {
            draft.makes.list = action.parameter.result;
        }
        if (!includes(draft.makes.list, draft.makes.selection)) {
            draft.makes.selection = "";
        }
    },
    "Custom/Ymme/MakeSelected": (draft: Draft<YmmeState>, action: any) => {
        draft.makes.selection = action.parameter;
    },
    "Custom/Ymme/MakesDataReset": (draft: Draft<YmmeState>, action: any) => {
        draft.makes.selection = "";
        draft.makes.list = [];
    },
    "Custom/Ymme/ModelsLoaded": (draft: Draft<YmmeState>, action: any) => {
        if (action.parameter.successful === false || action.parameter.result.length === 0) {
            draft.models.list = [];
        } else {
            draft.models.list = action.parameter.result;
        }
        if (!includes(draft.models.list, draft.models.selection)) {
            draft.models.selection = "";
        }
    },
    "Custom/Ymme/ModelSelected": (draft: Draft<YmmeState>, action: any) => {
        draft.models.selection = action.parameter;
    },
    "Custom/Ymme/ModelsDataReset": (draft: Draft<YmmeState>, action: any) => {
        draft.models.selection = "";
        draft.models.list = [];
    },
    "Custom/Ymme/YearsLoaded": (draft: Draft<YmmeState>, action: any) => {
        if (action.parameter.successful === false || action.parameter.result.length === 0) {
            draft.years.list = [];
        } else {
            draft.years.list = action.parameter.result;
        }
        if (!includes(draft.years.list, draft.years.selection)) {
            draft.years.selection = "";
        }
    },
    "Custom/Ymme/YearSelected": (draft: Draft<YmmeState>, action: any) => {
        draft.years.selection = action.parameter;
    },
    "Custom/Ymme/YearsDataReset": (draft: Draft<YmmeState>, action: any) => {
        draft.years.selection = "";
        draft.years.list = [];
    },
    "Custom/Ymme/EnginesLoaded": (draft: Draft<YmmeState>, action: any) => {
        if (action.parameter.successful === false || action.parameter.result.length === 0) {
            draft.engines.list = [];
        } else {
            draft.engines.list = action.parameter.result;
        }
        if (!includes(draft.engines.list, draft.engines.selection)) {
            draft.engines.selection = "";
        }
    },
    "Custom/Ymme/EngineSelected": (draft: Draft<YmmeState>, action: any) => {
        draft.engines.selection = action.parameter;
    },
    "Custom/Ymme/EnginesDataReset": (draft: Draft<YmmeState>, action: any) => {
        draft.engines.selection = "";
        draft.engines.list = [];
    },
});

(reducers as any).ymmeReducer = ymmeReducer;

export type CustomState = {
    ymmeReducer: YmmeState;
} & ApplicationState;

type Reducers = {
    ymmeReducer: typeof ymmeReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
